import { queryOptions, useQuery } from '@tanstack/react-query';
import { omit } from 'lodash-es';
import { z } from 'zod';
import { responseScheme } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

const semanticVersionSchema = z.string().regex(/^\d+\.\d+\.\d+$/);

export const versionsSchema = z
  .object({
    AndroidDownLoadUrl: z.string().length(0).or(z.string().url()),
    AndroidNewVersionName: semanticVersionSchema,
    IOSDownLoadUrl: z.string().length(0).or(z.string().url()),
    IOSOldVersionName: semanticVersionSchema,
    IOSNewVersionName: semanticVersionSchema,
    PCDownLoadUrl: z.string().length(0).or(z.string().url()),
    PCNewVersionName: semanticVersionSchema,
  })
  .strip();
type Versions = z.infer<typeof versionsSchema>;

const versionsQueryOptions = queryOptions({
  queryKey: ['/GetVersion'],
  queryFn: ({ signal }) =>
    fetcher<Versions>('/GetVersion', undefined, {
      method: 'get',
      schema: responseScheme.merge(versionsSchema),
      validResponseCodes: [0],
      signal,
      requireAuth: false,
    }).then((response) => omit(response, ['Code', 'Msg'])),
  staleTime: 30 * 60 * 1000, // 30 mins
  gcTime: 60 * 60 * 1000, // 1 hour
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
});

export default function useVersions() {
  return useQuery(versionsQueryOptions);
}
